import { faAngleDoubleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import Slider from "react-slick";
import { serverInfo } from "../../../../App";

const SubCategorySelector = ({
  onSelect,
  setOnSelect,
  catId,
  setCatId,
  selectSub,
  setSelectSub,
  selectMain,
  setSelectMain,
  subId,
  setSubId,
}) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [select, setSelect] = useState({
    selectedCheckboxes: [],
  });

  const onChange = (obj) => {
    const selectedCheckboxes = select.selectedCheckboxes;

    // Find index
    const findIdx = selectedCheckboxes.indexOf(obj);

    // Index > -1 means that the item exists and that the checkbox is checked
    // and in that case we want to remove it from the array and uncheck it
    if (findIdx > -1) {
      selectedCheckboxes.splice(findIdx, 1);
    } else {
      selectedCheckboxes.push(obj);
    }

    setSelect({
      selectedCheckboxes: selectedCheckboxes,
    });
  };

  const [imageInfo, setImageInfo] = useState({});

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    // <img src={LeftArrow} alt="prevArrow" {...props} />
    <FaArrowLeft {...props} />
  );

  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <FaArrowRight {...props} />
  );

  var settings = {
    autoplay: true,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  const [isCheck, setIsCheck] = useState([]);
  const [subCatList, setSubCatlist] = useState([]);

  // @TODO: Select Unselect Functionality
  const handleClick = (e) => {
    const { id, checked } = e.target;
    const parseId = parseInt(id);
    setIsCheck([...isCheck, parseId]);
    handleChange([...isCheck, parseId]);

    if (!checked) {
      const checked_data = isCheck.filter((item) => item !== parseId);
      setIsCheck(checked_data);
      handleChange(checked_data);
    }
  };

  function handleChange(data) {
    const formData = new FormData();

    formData.append("subcategory", JSON.stringify(data));

    axios.post(`/api/user/selected/subcategory/store`, formData).then((res) => {
      if (res.status === 200) {
      }
    });
  }

  useEffect(() => {
    axios.get(`/api/user/subcategory/${catId}`).then((res) => {
      if (res.status === 200) {
        setSubCatlist(res.data.allSubCat);
        setIsCheck(res.data.selectedSubCategory);
      }
    });
  }, []);

  const handleSelect = (id) => {
    if (!isCheck.includes(id)) {
      setSubId(id);
      setOnSelect(false);
      setSelectSub(true);
    }
  };

  const { selectedCheckboxes } = select;

  const handleBack = () => {
    setOnSelect(false);
    setSelectMain(true);
  };

  return (
    <div className="bgCategory container post-category-select containerCategorySelector mt-3">
      <div className="p-1 sliderCategory">
        <div className="d-flex">
          {/* <Link to="/"> */}{" "}
          <button
            onClick={() => handleBack()}
            className="btn btn-warning btnAngleDouble"
          >
            {" "}
            <FontAwesomeIcon icon={faAngleDoubleLeft} />
          </button>
          {/* </Link> */}
          <small className="text-white mx-2">Sub Category </small>
        </div>

        <Slider {...settings}>
          {subCatList.map((i, idx) => {
            return (
              <>
                <div key={i.id} className="p-1">
                  <div>
                    <img
                      onClick={() => handleSelect(i.id)}
                      src={imageCdnUrl + i.image}
                      alt=""
                      className="img-fluid homePageCarouselImg btn"
                    />
                  </div>
                  <div className="d-flex justify-content-center socialMedia">
                    <div className="mx-1">
                      <div className="content">
                        <label className="switch m5">
                          <input
                            key={i.id}
                            id={i.id}
                            name={i.name}
                            type="checkbox"
                            onChange={handleClick}
                            checked={isCheck?.includes(i.id)}
                          />
                          <small></small>
                        </label>
                      </div>
                    </div>
                    <small className="text-white mx-1">{i.name}</small>
                  </div>
                </div>
                { }
              </>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default SubCategorySelector;
